import { type AuthConfig } from "../config/client";
import { AUTH_CONFIG } from "../config/legacy-frozen-config";
import {
  exchangeToken as exchangeKcToken,
  forceInitWithExchangedToken as forceInitKcWithExchangedToken,
  getToken as getKcToken,
  getTokenP as getKcTokenP,
  initKeycloak,
  login as keycloakLogin,
  logout as keycloakLogout,
  onTokenUpdate as onKcTokenUpdate,
  patchRequests as patchKcRequests,
} from "./keycloak";
import {
  getSession as getMMSession,
  getToken as getMMToken,
  getTokenP as getMMTokenP,
  initMessageMediaAuth,
  logout as mmLogout,
  onTokenUpdate as onMMTokenUpdate,
  patchRequests as patchMMRequests,
  patchRefreshToken as patchMmRefreshToken,
} from "./messagemedia";
import {
  getToken as getOidcToken,
  getTokenP as getOidcTokenP,
  initOidc,
  login as oidcLogin,
  logout as oidcLogout,
  onTokenUpdate as onOidcTokenUpdate,
  patchRequests as patchOidcRequests,
} from "./oidc";
import type { AuthStrategy } from "./types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toBeImplemented: any = () => console.log("to be implemented");

const authStrategies: Record<AuthConfig["type"], AuthStrategy> = {
  kc: {
    init: initKeycloak,
    login: keycloakLogin,
    logout: keycloakLogout,
    exchangeToken: exchangeKcToken,
    forceInitWithExchangedToken: forceInitKcWithExchangedToken,
    getToken: getKcToken,
    getTokenP: getKcTokenP,
    onTokenUpdate: onKcTokenUpdate,
    patchRequests: patchKcRequests,
    getSession: toBeImplemented,
    patchRefreshToken: toBeImplemented,
  },
  mm: {
    init: initMessageMediaAuth,
    login: toBeImplemented,
    logout: mmLogout,
    exchangeToken: toBeImplemented,
    forceInitWithExchangedToken: toBeImplemented,
    getToken: getMMToken,
    getTokenP: getMMTokenP,
    patchRefreshToken: patchMmRefreshToken,
    onTokenUpdate: onMMTokenUpdate,
    patchRequests: patchMMRequests,
    getSession: getMMSession,
  },
  oidc: {
    init: initOidc,
    login: oidcLogin,
    logout: oidcLogout,
    exchangeToken: toBeImplemented,
    forceInitWithExchangedToken: toBeImplemented,
    getToken: getOidcToken,
    getTokenP: getOidcTokenP,
    patchRefreshToken: toBeImplemented,
    onTokenUpdate: onOidcTokenUpdate,
    patchRequests: patchOidcRequests,
    getSession: toBeImplemented,
  },
  tbi: {
    init: toBeImplemented,
    login: toBeImplemented,
    logout: toBeImplemented,
    exchangeToken: toBeImplemented,
    forceInitWithExchangedToken: toBeImplemented,
    getToken: toBeImplemented,
    getTokenP: toBeImplemented,
    patchRefreshToken: toBeImplemented,
    onTokenUpdate: toBeImplemented,
    patchRequests: toBeImplemented,
    getSession: toBeImplemented,
  },
};

const initAuth = authStrategies[AUTH_CONFIG.type].init;
export const patchRequestsWithAuth =
  authStrategies[AUTH_CONFIG.type].patchRequests;
export const login = authStrategies[AUTH_CONFIG.type].login;
export const logout = authStrategies[AUTH_CONFIG.type].logout;
export const getToken = authStrategies[AUTH_CONFIG.type].getToken;
export const getTokenP = authStrategies[AUTH_CONFIG.type].getTokenP;
export const onTokenUpdate = authStrategies[AUTH_CONFIG.type].onTokenUpdate;
export const exchangeToken = authStrategies[AUTH_CONFIG.type].exchangeToken;
export const forceInitWithExchangedToken =
  authStrategies[AUTH_CONFIG.type].forceInitWithExchangedToken;
export const getSession = authStrategies[AUTH_CONFIG.type].getSession;
export const patchRefreshToken =
  authStrategies[AUTH_CONFIG.type].patchRefreshToken;

export const setupAuth = (patchRequests: boolean) => {
  initAuth();
  if (patchRequests) {
    patchRequestsWithAuth();
  }
};
